import { getApiLinkFromHostnameAndEnv } from "../../../domain/models/Enviroment";

export const getApiUrl = (): string =>
    getApiLinkFromHostnameAndEnv("web", window.location.hostname);
